import * as Sentry from "@sentry/browser";

const env = process.env.MIX_ENVIRONMENT ?? 'local';

if (env === 'production' || env === 'staging') {
    const sentryConfig = {
        dsn: "https://98e76ae15a9bef8c3d61c783da95b233@o4508714976215040.ingest.de.sentry.io/4508716503662672",
        environment: env,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 0.01,
        // Session Replay
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 0.05,
    };

    if (env === 'production') {
        sentryConfig.allowUrls = [/^https:\/\/centerstage\.airlst\.app/];
    }

    Sentry.init(sentryConfig);
}
